import Approve from './Approve'
import AssignModerator from './AssignModerator'
import ChangeAuthor from './ChangeAuthor'
import CloseTopic from './CloseTopic'
import MarkAsNotSpam from './MarkAsNotSpam'
import MarkAsSpam from './MarkAsSpam'
import createMoveToComponent from './MoveTo'
import PermanentlyDelete from './PermanentlyDelete'
import TrashTopic from './TrashTopic'

export {
  Approve,
  AssignModerator,
  ChangeAuthor,
  CloseTopic,
  MarkAsNotSpam,
  MarkAsSpam,
  createMoveToComponent,
  PermanentlyDelete,
  TrashTopic
}
